<template>
  <div :class="$style.ctn">
    <Stats :class="$style.stats" :values="filesActivity.stats" />
    <h3 :class="[com.subtitle, $style.title]">
      Dropped files
    </h3>
    <PaginationTable
      :class="$style.table"
      :head="filesHead"
      :values="filesActivity.droppedFiles"
      :pagination-detach="true"
      :table-wrapper-class="media.filesTableWrapper"
    >
      <template #row="props">
        <tr
          v-show="props.show"
          :class="[$style.row, $style.rowTop, { [$style.rowFirst]: props.isFirst }]"
        >
          <td>
            <span>
              <b>{{ props.row.pid }}</b>
            </span>
          </td>
          <td>
            <span>{{ props.row.process }}</span>
          </td>
          <td colspan="2">
            <span>{{ props.row.filename }}</span>
          </td>
          <td>
            <span>
              <Badge :full-width="true" :type="props.row.type.type" :value="props.row.type.value" />
            </span>
          </td>
        </tr>
        <tr
          v-show="props.show"
          :class="[
            $style.row,
            $style.rowBot,
            { [$style.rowLast]: props.isLast, [$style.rowLastPrint]: props.isLastPrint },
          ]"
        >
          <td colspan="2">
            <span />
          </td>
          <td>
            <div>
              <div :class="$style.spanValue">
                <b>MD5:</b>
                <span>{{ props.row.md5 }}</span>
              </div>
            </div>
          </td>
          <td colspan="2">
            <div>
              <div :class="$style.spanValue">
                <b>SHA256:</b>
                <span>{{ props.row.sha256 }}</span>
              </div>
            </div>
          </td>
        </tr>
      </template>
      <template #footer>
        <TipMessage :class="$style.tipMessage" :full-report-link-at-end="true">
          Download PCAP, analyze network streams, HTTP content and a lot more at the
        </TipMessage>
      </template>
    </PaginationTable>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import PaginationTable from './PaginationTable.vue';
import Stats from './Stats.vue';
import TipMessage from './TipMessage.vue';
import Badge from './Badge.vue';

export default defineComponent({
  components: {
    Stats,
    PaginationTable,
    TipMessage,
    Badge,
  },
  inject: ['root'],
  data: () => ({
    filesHead: [
      { value: 'PID', width: 58 },
      { value: 'Process', width: 170 },
      { value: 'Filename', width: 316 },
      { value: '', width: 424 },
      { value: 'Type', width: 112 },
    ],
  }),
  computed: {
    filesActivity() {
      return this.root.filesActivity;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  padding-top: 20px;
}

.stats {
  & + .title {
    margin-top: 40px;
  }
}

.row {
  &:nth-child(4n - 1),
  &:nth-child(4n) {
    & > td > *::before {
      background: var(--secondary-cell-color);
    }
  }

  & > td {
    & > * {
      font-size: 12px;
      display: block;
      overflow-wrap: anywhere;
      word-break: break-word;
      padding-top: 6px;
      color: #2f3543;
      padding-left: 10px;

      b {
        font-weight: 500;
      }
    }

    &:first-child > * {
      padding-left: 14px;
    }

    &:first-child > *::before {
      border-left: 1px solid var(--table-border-color);
    }

    &:last-child > * {
      padding-right: 10px;
      &::before {
        border-right: 1px solid var(--table-border-color);
      }
    }
  }
}

.rowTop {
  & > td > * {
    padding-top: 10px;
  }
}
.rowBot {
  & > td {
    & > * {
      padding-bottom: 10px;
      &::before {
        border-bottom: 1px solid var(--table-border-color);
      }
    }
  }
}

@media not print {
  .rowLast > td {
    &:first-child > *::before {
      border-bottom-left-radius: 6px;
    }
    &:last-child > *::before {
      border-bottom-right-radius: 6px;
    }
  }
}

@media print {
  .rowLastPrint > td {
    &:first-child > *::before {
      border-bottom-left-radius: 6px;
    }
    &:last-child > *::before {
      border-bottom-right-radius: 6px;
    }
  }
}

.spanValue {
  display: flex;
  & > *:nth-child(odd) {
    flex: none;
  }
  & > *:nth-child(even) {
    overflow-wrap: anywhere;
    word-break: break-word;
    color: #2f3543;
    padding-left: 4px;
    font-weight: normal;
  }
}
.title + .table {
  margin-top: 15px;
}
* + .tipMessage {
  margin-top: 15px;
}
.tipMessage + * {
  margin-top: 20px;
}

.table {
  --padding-left-right: 14px;
}
</style>
<style lang="scss" src="./common.module.scss" module="com"></style>
<style lang="scss" src="./media.module.scss" module="media"></style>
